import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowShrinkOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowShrinkOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="m22.206 3.21-1.42-1.42L14 8.59V1.98L12 3.99V12h7.987l1.999-2h-6.567l6.787-6.79ZM4.003 12l-2.009 2h6.597l-6.797 6.79 1.42 1.42L10 15.41V22L12 20v-8H4.003Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ArrowShrinkOutlined;